import type { RuntimeConfigOverrides } from '../app/core/config/runtime-config.model';

export const environment: { runtimeConfig: RuntimeConfigOverrides } = {
  runtimeConfig: {
    environment: {
      target: 'dev'
    }
  }
};
